import { IReservationVariant } from '../../graphql/parkingPool/getParkingPoolAvailability'
import { reasonKey } from './reservationDayState'

const availableDays = (v: IReservationVariant) =>
  v.days.filter(d => d.available)

export const hasAvailableDay = (v: IReservationVariant) =>
  v.days.some(d => d.available)

export const noVariantsReasonKey = (variants: IReservationVariant[]) => {
  const codes = new Set(
    variants.flatMap(v =>
      v.days.filter(d => !d.available).map(d => d.reasonCode),
    ),
  )
  const [code] = Array.from(codes)
  if (codes.size !== 1 || !code || code === 'IN_THE_PAST') return null
  if (code === 'POOL_FULL') return 'reserve_modal.no_variants_pool_full'
  return reasonKey(code, 'blocked')
}

export const isSingleHall = (v: IReservationVariant) =>
  new Set(availableDays(v).map(d => d.parkingName)).size === 1

export const singleHallName = (v: IReservationVariant) =>
  availableDays(v)[0]?.parkingName ?? ''

export const mixedRows = (v: IReservationVariant) => {
  const rows: { name: string; label: string }[] = []
  const pad = (n: number) => String(n).padStart(2, '0')
  const fmt = (s: string) => {
    const d = new Date(s.slice(0, 10))
    return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}`
  }
  availableDays(v).forEach(d => {
    const last = rows[rows.length - 1]
    if (last && last.name === d.parkingName)
      last.label = `${last.label.split('–')[0]}–${fmt(d.day)}`
    else rows.push({ name: d.parkingName, label: fmt(d.day) })
  })
  return rows
}
